import { render } from "./HeroiconsSolidChevronDown.vue?vue&type=template&id=1838d352"
const script = {}

import exportComponent from "C:\\laragon\\www\\bipay-payg\\vendor\\laravel\\nova\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidChevronDown.vue"]])

export default __exports__